import { KeeperDetail, PropChallenge, PropChallengeChallengeStatusEnum } from 'services/generatedClientFromSwagger';

export const challengeKeeperKey = 'challengeKeeper';

export const isKeeperActive = (keeperDetail?: KeeperDetail) => {
    return keeperDetail && keeperDetail?.active && keeperDetail?.hit && !keeperDetail?.purchased;
};

export const verifyChallengeKeeper = (challenge?: PropChallenge) => {
    if (!challenge) {
        return false;
    }

    const { keeper } = challenge;

    return (
        challenge?.challengeStatus === PropChallengeChallengeStatusEnum.Active &&
        ((keeper?.maxDaily && isKeeperActive(keeper.maxDaily)) || (keeper?.maxTotal && isKeeperActive(keeper.maxTotal)))
    );
};

export const verifyExtendMyLimit = (challenge?: PropChallenge) => {
    if (!challenge) {
        return false;
    }
    const { keeper } = challenge;

    return (
        challenge?.challengeStatus === PropChallengeChallengeStatusEnum.Active &&
        ((keeper?.maxDaily && isKeeperActive(keeper.maxDaily)) || (keeper?.maxTotal && isKeeperActive(keeper.maxTotal)))
    );
};
